import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useNavigateToJoinedCommunities = () => {
  const navigate = useNavigate();

  return useCallback(async () => {
    await navigate(routes.community.index);
  }, [navigate]);
};
